export interface ObjectTypeType extends ObjectTypeRequestType {
  id: number
}

export interface ObjectTypeTypeShort {
  id: number
  name: string
  icon: string
  is_system: boolean
  /** Количество дочерних элементов (инвентаризационных типов) */
  elements_count?: number
  /** Родительский инвентаризационный тип группы */
  parent_id?: number | null
  parent_name?: string | null
  /** Первый дочерний элемент (для groups из одного элемента) */
  first_element_id?: number | null
  first_element_name?: string | null
}

export enum ObjectTypeFunctionalType {
  STANDARD = 'STANDARD',
  UNIVERSAL = 'UNIVERSAL',
  DEPENDENT = 'DEPENDENT',
  GROUPING = 'GROUPING',
}

export interface ObjectTypeRequestType {
  object_name: string
  icon: string
  description: string
  default_group_object_id: number
  alias: string
  is_tab: boolean
  is_system: boolean
  functional_type: ObjectTypeFunctionalType
  dependencies_list: number[]
}

export type ObjectTypeDataPayloads = {
  types: {
    id: number
    object_name: string
    icon: string
  }[]
  figures: {
    id: number
    name: string
  }[]
  lines: {
    id: number
    name: string
  }[]
}
